import styled from "styled-components";
import { SINGLE_FILTERS_ROW_BREAKPOINT } from "@shared/features/filters/constants";
import Input from "common/Inputs/Input";
import Button from "common/Buttons/Button";
import { BOTTOM_NAVIGATOR } from "common/constants.ts";

export const FilterChipsWrapper = styled.div<{
  $showingBottomNavigator?: boolean;
}>`
  @media (max-width: ${SINGLE_FILTERS_ROW_BREAKPOINT}) {
    padding: 0 12px;
    display: flex;
    justify-content: flex-start;
    overflow-x: auto;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  ${(p) =>
    p.$showingBottomNavigator &&
    `
      padding: 6px 12px 6px 8px !important;
      border-bottom: 1px solid ${p.theme.colors.lightBorderGrey}; 
    `};
`;

export const StyledInput = styled(Input)<{
  $showClear?: boolean;
  $isSingleRowView?: boolean;
  $hasValue?: boolean;
}>`
  cursor: pointer;
  input {
    cursor: pointer;
  }
  .ant-input-suffix {
    display: none;
  }
  ${(p) =>
    p.$showClear &&
    `
    .ant-input-suffix {
      display: block;
    }
    .ant-input-clear-icon {
      visibility: visible;
    }
  `};
  ${(p) =>
    p.$isSingleRowView &&
    `
    height: 32px;
    background: ${p.theme.colors.filterChipsColor} !important;
    border: none !important;
    border-radius: 50px !important;
    box-shadow: none !important;
    text-align: center; 
    input.ant-input::placeholder, &.ant-input::placeholder {
      color: ${p.theme.colors.primaryGrey} !important; 
      text-align: center; 
    }
   
    &&& {
      &.ant-input {
        background: ${p.theme.colors.filterChipsColor} !important;
        text-align: center; 
      }
    }
    .ant-input-clear-icon {
      background: ${p.theme.colors.filterChipsColor} !important;
      color: ${p.theme.colors.lightestGrey} !important;
    }
  `};

  @media (max-width: ${BOTTOM_NAVIGATOR}) {
    ${(p) =>
      p.$hasValue &&
      `
     background: ${p.theme.colors.filterChipsActiveColor} !important;
     color: ${p.theme.colors.white} !important;
  `};
  }
`;

export const MobileResetButton = styled(Button).attrs({ type: "primary" })`
  width: 100%;
  height: 40px;
`;
